"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOutsideClickNotifier = void 0;
var react_1 = require("react");
function useOutsideClickNotifier(ref, state, onClick, appendListenerToElement) {
    var onClickRef = (0, react_1.useRef)(onClick);
    (0, react_1.useEffect)(function () {
        onClickRef.current = onClick;
    }, [onClick]);
    (0, react_1.useEffect)(function () {
        var _a;
        if (state === 'idle') {
            return;
        }
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                onClickRef.current(event);
            }
        }
        var element = (_a = appendListenerToElement === null || appendListenerToElement === void 0 ? void 0 : appendListenerToElement.current) !== null && _a !== void 0 ? _a : document;
        element.addEventListener('mousedown', handleClickOutside);
        return function () {
            element.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, state, appendListenerToElement]);
}
exports.useOutsideClickNotifier = useOutsideClickNotifier;
//# sourceMappingURL=useOutsideClickNotifier.js.map